const AbstractItem = require('@/lib/Items/AbstractItem');
const ItemType = require('@/lib/Items/ItemType');

class DeliveryMethod extends AbstractItem {
    constructor() {
        super();

        this.icon = 'fa-truck';
        this.itemType = ItemType.DELIVERY_METHOD;
    }
}

module.exports = DeliveryMethod;
